import { EventEmitter, Injectable } from '@angular/core';
import { UrlSerializer, UrlTree } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';
import { AutoUnsubscribe } from '../../core/auto-unsubscribe';
import { LanguageService } from '../../core/language.service';

@AutoUnsubscribe()
@Injectable({
  providedIn: 'root',
})
export class AjsFrameService {
  subs = new SubSink();

  visible = new BehaviorSubject<boolean>(false);
  loaded = new BehaviorSubject<boolean>(false);

  openRegisterDialogEvent = new EventEmitter();

  navigateEvent = new EventEmitter<string>();
  navigateCompleteEvent = new EventEmitter();

  constructor(
    private serializer: UrlSerializer,
    private languageService: LanguageService
  ) {
    this.loaded.subscribe(s => {
      this.languageService.notifyAjs();
    });
  }

  navigate(url: UrlTree | string): void {
    if (url instanceof UrlTree) {
      const urlTree = this.serializer.serialize(url);
      this.navigateEvent.emit(urlTree);
    } else {
      this.navigateEvent.emit(url);
    }
  }

  show(): void {
    this.visible.next(true);
  }

  hide(): void {
    this.visible.next(false);
  }

  toggleVisibility(): void {
    this.visible.next(!this.visible.value);
  }

  openRegisterDialog() {
    if (this.visible.value == false) this.show();
    this.openRegisterDialogEvent.emit();
  }
}
